import { STATUS_REQUERIMENTO, ENUM_CARGO } from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';

export const isBloquearButton = (statusRequerimento, atendenteLogado) => {
  let isDisabled = false;
  if (
    statusRequerimento === STATUS_REQUERIMENTO.FINALIZADO_DEFERIDO.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.FINALIZADO_PROCESSO_GERADO.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.FINALIZADO_INDEFERIDO.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.SOLICITACAO_ATENDIDA.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador ||
    statusRequerimento === STATUS_REQUERIMENTO.CANCELADO.identificador
  ) {
    isDisabled = true;
  }

  if (
    (statusRequerimento === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador ||
      statusRequerimento === STATUS_REQUERIMENTO.DIRECIONADO_OUTRO_ATENDENTE.identificador) &&
    atendenteLogado?.cargoId === ENUM_CARGO.SUPERVISOR_SETORIAL
  ) {
    isDisabled = true;
  }
  return isDisabled;
};

export const filtrarStatus = (todosStatus, identificador) => {
  return todosStatus.find(x => x.identificador === identificador);
};

export const isShowButtonIniciar = (user, statusIdentificadorRequerimento) => {
  if (user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR || user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL) {
    if (
      statusIdentificadorRequerimento === STATUS_REQUERIMENTO.ABERTO.identificador ||
      statusIdentificadorRequerimento === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador ||
      statusIdentificadorRequerimento === STATUS_REQUERIMENTO.DIRECIONADO_OUTRO_ATENDENTE.identificador
    ) {
      return true;
    }
  }
  return false;
};
